.root {
  align-self: center;
  justify-self: center;
  width: 100%;
  height: 100%;
  color: var(--on-background);
  text-align: center;

  /* make it visual vertical center */
  &:not(.compact) {
    transform: translateY(-28px);
  }

  abbr[title] {
    text-decoration: none;
  }

  /* bootstrap adds the full text in print - remove that */
  @media print {
    abbr[title]::after {
      content: "";
    }
  }

  @media (--md-down) {
    &.size12,
    &.size6,
    &.size4,
    &.size3 {
      .count {
        font-size: 3rem;
      }
    }
  }

  @media (--lg-up) {
    &.size4 {
      .count {
        font-size: 4.5rem;
      }
    }
  }

  .count {
    font-size: 3rem;
    line-height: 1;
  }

  /* compact size */
  &.compact {
    .count {
      font-size: 3rem;
      line-height: 1;
    }

    @media (--xl-down) {
      &.size3,
      &.size4,
      &.size6 {
        .count {
          font-size: 2rem;
        }
      }
    }

    @media (--xl-up) {
      &.size3,
      &.size4 {
        .count {
          font-size: 3rem;
        }
      }
    }
  }
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  h5 {
    margin-bottom: 0;
  }
}

.row {
  flex-direction: column;
}
